import { Wallet, Check, Clock, DollarSign, Undo2 } from 'lucide-react'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { CurrencyPaymentStatus } from '@/interfaces/billing'

interface PaymentStatusFilterProps {
  selectedPaymentStatus: string | null
  onPaymentStatusChange: (_statusValue: string | null) => void
  className?: string
}

const paymentStatusOptions: {
  value: CurrencyPaymentStatus
  label: string
  color: string
  icon: React.ReactNode
}[] = [
  {
    value: 'CONFIRMED_PAYMENT',
    label: 'Confirmado',
    color: 'bg-green-100 text-green-800',
    icon: <Check className="mr-2 h-3 w-3" />,
  },
  {
    value: 'PREPAID_PAYMENT',
    label: 'Anticipado',
    color: 'bg-yellow-100 text-yellow-800',
    icon: <DollarSign className="mr-2 h-3 w-3" />,
  },
  {
    value: 'PARTIAL_PAYMENT',
    label: 'Parcial',
    color: 'bg-blue-100 text-blue-800',
    icon: <Clock className="mr-2 h-3 w-3" />,
  },
  {
    value: 'REFUND',
    label: 'Reembolsado',
    color: 'bg-violet-200 text-violet-800',
    icon: <Undo2 className="mr-2 h-3 w-3" />,
  },
]

export const PaymentStatusFilter = ({
  selectedPaymentStatus,
  onPaymentStatusChange,
  className,
}: PaymentStatusFilterProps) => {
  const handleToggle = (statusValue: string) => {
    onPaymentStatusChange(statusValue)
  }

  return (
    <div className={className}>
      <div className="mb-3 flex items-center gap-2">
        <Wallet className="h-4 w-4" />
        <Label className="text-sm font-medium">Estado del pago</Label>
      </div>

      <div className="space-y-2">
        {paymentStatusOptions.map((option) => {
          const isSelected = selectedPaymentStatus === option.value

          return (
            <div className="flex items-center space-x-2" key={option.value}>
              <Checkbox
                checked={isSelected}
                id={`status-${option.value}`}
                onCheckedChange={() => handleToggle(option.value)}
              />
              <Label
                className={
                  `inline-flex cursor-pointer items-center rounded-full ` +
                  `px-2.5 py-0.5 text-sm font-medium ${option.color}`
                }
                htmlFor={`status-${option.value}`}
              >
                {option.icon}
                {option.label}
              </Label>
            </div>
          )
        })}
      </div>
    </div>
  )
}
